import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-slotcard-reward-modal',
  templateUrl: './slotcard-reward.component.html',
  styleUrls: ['./slotcard-reward.component.scss'],
  standalone: true,
  imports: [DisplayComponent, ButtonComponent, SharedModule],
})
export class SlotcardRewardModalComponent implements OnInit {
  slotcardRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private translateService = inject(TranslateService);

  lang: string;
  slotcard: LimitedTimeEvent;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.slotcardRewardModalData.id, ModalType.Persisted, this.slotcardRewardModalData)
    );
  }
}
